import React from 'react'
import { MdDone, MdCheck } from 'react-icons/md'

import { Grid } from '@material-ui/core'

import Button from '../../../shared/components/Button'
import Modal from '../../../shared/components/Modal'
import { colors } from '../../../shared/styles/colors'
import { IExcluirProps } from './ExcluirComponent.types'
import { TitleModal, SubTitleModal, StyledCheck } from './styles'

export const Excluir: React.FC<IExcluirProps> = ({
  openModalDeletar,
  onCloseModal,
  title,
  subTitle,
  deletado,
  titleDeletado,
  subTitleDeletado,
  idSelecionado,
  onDelete,
  buttonLabel,
  buttonColor,
}) => {
  return (
    <Modal
      openModal={openModalDeletar}
      showCloseButton={true}
      size="medium"
      onCloseModal={onCloseModal}
    >
      <Grid
        container
        spacing={3}
        justifyContent="center"
        alignItems="center"
        alignContent="center"
      >
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <StyledCheck />
        </Grid>
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          {!deletado && <TitleModal>{title}</TitleModal>}
          {!deletado && <SubTitleModal>{subTitle}</SubTitleModal>}
          {deletado && <TitleModal>{titleDeletado}</TitleModal>}
          {deletado && subTitleDeletado && (
            <TitleModal>{titleDeletado}</TitleModal>
          )}
        </Grid>
        <Grid item>
          {!deletado && (
            <Button
              color={buttonColor || colors.red}
              onClick={() => {
                onDelete(idSelecionado)
              }}
            >
              <MdCheck /> {buttonLabel || 'Sim, excluir'}
            </Button>
          )}

          {deletado && (
            <Button color={colors.orange} onClick={onCloseModal}>
              <MdDone /> Concluir
            </Button>
          )}
        </Grid>
      </Grid>
    </Modal>
  )
}

export default Excluir
